import classNames from 'classnames'
import React, { ReactNode } from 'react'

export type GridGutter = 'default' | 'none' | 'mobile' | 'large'

export interface GridProps {
    children: ReactNode
    reverse?: string[]
    justify?: string[]
    align?: string[]
    equalHeight?: boolean
    gutter?: GridGutter
    horizontalGutter?: GridGutter
    className?: string
    noWrap?: string[] | boolean
    verticalGutter?: GridGutter
    wrap?: string[]
}

export const Grid = (props: GridProps): JSX.Element => {
    const { gutter = 'default', horizontalGutter, wrap = props.noWrap ? undefined : ['xs'], verticalGutter } = props

    const className: string = classNames(
        'grid',
        {
            'grid--equalheight': props.equalHeight,
            [`grid--gutter-${gutter}`]: gutter,
            [`grid--vertical-gutter-${verticalGutter}`]: verticalGutter,
            [`grid--horizontal-gutter-${horizontalGutter}`]: horizontalGutter,
        },
        props.reverse?.map((reverse: string) => 'grid--reverse-' + reverse),
        props.justify?.map((justify: string) => 'grid--' + justify),
        props.align?.map((align: string) => 'grid--' + align),
        props.noWrap && Array.isArray(props.noWrap)
            ? props.noWrap.map((noWrap: string) => 'grid--no-wrap-' + noWrap)
            : 'grid--no-wrap-xs',
        wrap ? wrap.map((val: string) => 'grid--wrap-' + val) : null,
        props.className,
    )

    return <div className={className}>{props.children}</div>
}
